module.exports = __webpack_public_path__ + "img/Group 1504.e439a749.svg";